import React, {useRef, useReducer, useState} from "react";
import i18n from 'i18next';
import Modal from "@/Components/Modals/Modal";
import {Dialog} from '@headlessui/react';
import ModalFooter from "@/Components/Modals/ModalFooter";
import styles from '@/../sass/components/SubscriptionCancellationModal.module.scss';
import {Inertia} from "@inertiajs/inertia";

export default function SubscriptionCancellationConfirmation({dateOfRenewal, isOpen, cancellationErrorExists, cancellationError, cancellationToken, cancellationReasons, setIsOpen, onSuccess, onError}) {
    let initialFocusRef = useRef(null);

    function reducer(state, action) {
        switch (action.type) {
            case "step":
                return {...state, step: action.payload.step, errorMessage: action.payload.errorMessage}
        }
    }

    const [state, dispatch] = useReducer(reducer, {
        step: cancellationErrorExists ? 4 : 1, errorMessage: "",
    })

    const [selectedCancelReason, setSelectedCancelReason] = useState('');
    const [disabled, setDisabled] = useState(true);

    const handleSelectCancelReasonChange = (event) => {
        (event.target.value != '') ? setDisabled(false) : setDisabled(true);
        setSelectedCancelReason(event.target.value);
    };

    const data = {
        token: cancellationToken,
        cancelReason: selectedCancelReason
    };

    const confirmCancellation = () => {
        axios.post(route('organization.subscription.cancellation.cancel'), data)
            .then(
                res => {
                    let errorMessage = "";
                    let stepValue = 3;
                    if(res.data.code !== 204) {
                        errorMessage = res.data.message;
                        stepValue = 5;
                    }
                    dispatch(
                        {
                            type: "step",
                            payload: {
                                step: stepValue,
                                errorMessage: errorMessage
                            }
                        }
                    )
                    resetUrlToAccountOverview();
                }
            )
    }

    const reverseCancellation = () => {
        axios.post(route('organization.subscription.cancellation.abandon'), data)
            .then(
                res => {
                    let errorMessage = "";
                    let stepValue = 2;
                    if(res.data.code !== 204) {
                        errorMessage = res.data.message;
                        stepValue = 6;
                    }
                    dispatch(
                        {
                            type: "step",
                            payload: {
                                step: stepValue,
                                errorMessage: errorMessage
                            }
                        }
                    )
                    resetUrlToAccountOverview();
                }
            )
    }

    const resetUrlToAccountOverview = () => {
        let currentURL = window.location.href;
        if (currentURL.includes("confirm-cancellation=1")) {
            let newURL = currentURL.split("?")[0];
            window.history.replaceState(null, null, newURL);
        }
    }

    const renewalComplete = () => {
        setIsOpen(false);
        Inertia.visit(route('manage.account-overview'));
    }

    const cancellationComplete = () => {
        setIsOpen(false);
        Inertia.visit(route('manage.account-overview'));
    }

    const cancellationErrorComplete = () => {
        setIsOpen(false);
        Inertia.visit(route('manage.account-overview'));
    }

    if (state.step === 1) {
        return (
            <Modal
                title={i18n.t("cancel-confirm.cc-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                disableCloseButton={true}
            >
                <div className={styles.content}>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-confirm.cc-modal-info")} {dateOfRenewal}.
                        <br/><br/>
                        {i18n.t("cancel-confirm.cc-modal-reason-request")}
                        <br/>
                    </Dialog.Description>
                    <div>
                        <select class="form-select cancel-reason-select" value={selectedCancelReason} onChange={handleSelectCancelReasonChange}>
                            <option value="" selected>{i18n.t("cancel-confirm.cancel-reasons.Select Reason")}</option>
                            {Object.keys(cancellationReasons).map(id => (
                                <option key={id} value={cancellationReasons[id]}>{i18n.t("cancel-confirm.cancel-reasons." + cancellationReasons[id])}</option>
                            ))}
                        </select>
                    </div>
                    <br/>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-outline-dark"
                        onClick={() => reverseCancellation()}
                        style={{ marginRight: '6px'}}
                    >{i18n.t("cancel-confirm.cc-modal-button-renew")}
                    </button>
                    <button
                        className="btn btn-danger"
                        onClick={() => confirmCancellation()}
                        style={{ marginRight: '6px'}}
                        disabled={disabled}
                    >{i18n.t("cancel-confirm.cc-modal-button-cancel")}
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
    else if (state.step === 2) {
        return (
            <Modal
                title={i18n.t("cancel-confirm.renewed-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                disableCloseButton={true}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-confirm.renewed-modal-content")}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => renewalComplete()}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-confirm.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
    else if (state.step === 3) {
        return (
            <Modal
                title={i18n.t("cancel-confirm.cancelled-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                disableCloseButton={true}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-confirm.cancelled-modal-content")} {dateOfRenewal}.
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => cancellationComplete()}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-confirm.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
    else if (state.step === 4) {
        return (
            <Modal
                title={i18n.t("cancel-confirm.cant-process-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                disableCloseButton={true}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-confirm.validate " + cancellationError)}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => cancellationErrorComplete()}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-confirm.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
    else if (state.step === 5) {
        return (
            <Modal
                title={i18n.t("cancel-confirm.cant-process-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                disableCloseButton={true}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-confirm.cancel " + state.errorMessage)}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => cancellationErrorComplete()}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-confirm.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
    else if (state.step === 6) {
        return (
            <Modal
                title={i18n.t("cancel-confirm.cant-process-modal-title")}
                initialFocusRef={initialFocusRef}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                disableCloseButton={true}
            >
                <div>
                    <Dialog.Description as="p" ref={initialFocusRef}>
                        {i18n.t("cancel-confirm.renew " + state.errorMessage)}
                    </Dialog.Description>
                </div>
                <ModalFooter>
                    <button
                        className="btn btn-primary"
                        onClick={() => cancellationErrorComplete()}
                        style={{marginRight: '6px'}}
                    >{i18n.t("cancel-confirm.modal-okay-button")}
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}
